import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  AppBar,
  Avatar,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Switch,
  Toolbar,
  TextField,
} from "@mui/material";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ProfileIcon } from "../Icons/profileIcon";
import { setConfirmed } from "../_redux/UnsavedSlice";
import {
  updateUserDetailsAsync,
  updateUserDetailsStartReducer,
} from "../_redux/_services/UserManagerSlice";
import { Encrypt, decrypt } from "../_utilities/_encryptDecryptHelper";
import { setBreadCrumb } from "../_utilities/breadCrumb";
import { getUserDetails } from "../_utilities/getUserInfo";
import { authService } from "../api/authApi";
import { persistor, resetStore } from "../store";
import RightSideBar from "../components/Rightsidebar/RightSideBar";
import { FocusError } from "focus-formik-error";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ProfileEditIcon } from "../Icons/ProfileEditIcon";
import { ApplicantsIcon } from "../Icons/ApplicantsIcon";
import { getIn } from "formik";
import { updateLoader } from "../_redux/LoaderSlice";
import { clearAuth, updateAuth } from "../_redux/AuthSlice";
import { GlobeIcon } from "../Icons/globeIcon";
import { UserIcon3 } from "../Icons/userIcon3";
import { resetSelectedApplicant } from "../_redux/SelectedApplicantSlice";
import { refreshOutlet, toggleSidebar } from "../_redux/Uislice";
import { resetHighlightFilter } from "../_redux/HighlightSlice";
import { resetSelectedJobPosting } from "../_redux/SelectedJobPostingSlice";
import { jobpostingsbyidStartReducer } from "../_redux/_services/JobPostingSlice";

const label = { inputProps: { "aria-label": "Switch demo" } };

const initalState = { data: null, message: "", isloader: true };

const getApplicantPath = () => {
  const userinfo = getUserDetails();
  if (userinfo?.systemroles === "Field Recruiter") {
    return "/ats/layout/applicants/list/landing";
  }
  return (
    Cookies.get("applicantViewPreference") || "/ats/layout/applicants/landing"
  );
};

const getJobPostingPath = () => {
  return "/ats/layout/jobpostings/landing";
};

const pages = [
  {
    id: 1,
    path: getJobPostingPath(),
    displayName: "Job Postings",
    isActive: false,
  },
  {
    id: 2,
    path: getApplicantPath(),
    displayName: "Applicants",
    isActive: false,
  },
  {
    id: 3,
    path: "/ats/layout/clients/landing",
    displayName: "Clients",
    isActive: false,
  },
  {
    id: 4,
    path: "/ats/layout/projects/landing",
    displayName: "Projects",
    isActive: false,
  },
  {
    id: 5,
    path: "/ats/layout/reports/dashboard",
    displayName: "Reports",
    isActive: false,
  },
];

const DEFAULT_LOGO = process.env.PUBLIC_URL + "/assests/HireWing.png";

function Header({ selectedCountry, setSelectedCountry }) {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [userCountries, setUserCountries] = useState(null);
  const [selectedCountryHold, setSelectedCountryHold] = useState(null);
  const [GetUserInfo, setgetUserInfo] = useState(null);
  const [loggedOut, setLoggedOut] = useState(false);
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [updateNumbers, setUpdateNumbers] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [customerID, setCustomerID] = useState(null);
  const [finalPages, setFinalPages] = useState([]);
  const location = useLocation();
  const { themeSettings } = useSelector((state) => state.theme);
  const hasUnsaved = useSelector((state) => state.Unsaved.hasUnsavedChanges);
  const { storedApplicant } = useSelector((state) => state.SelectedApplicant);
  const { storedJobPosting } = useSelector((state) => state.SelectedJobPosting);

  const [storedApplicantdata, setStoredApplicantdata] = useState(null);
  const [storedJobPostingData, setStoredJobPostingData] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const isConfirmedPopup = useSelector(
    (state) => state.Unsaved.isConfirmedType,
  );
  const [logoUrl, setLogoUrl] = useState("");
  const [isLogoLoading, setIsLogoLoading] = useState(true);
  const [allCountries, setAllCountries] = useState(
    JSON.parse(decrypt("allCountryId")) === "all" ? false : true,
  );
  const [dashboardPath, setDashboardPath] = useState("");
  const [appTheme, setTheme] = useState({});
  useEffect(() => {
    // async function init() {

    // }
    // init();
    getUserData();
  }, []);

  useEffect(() => {
    if (storedApplicant !== null) {
      setStoredApplicantdata(storedApplicant);
    }
  }, [storedApplicant]);

  useEffect(() => {
    if (storedJobPosting !== null) {
      setStoredJobPostingData(storedJobPosting);
    }
  }, [storedJobPosting]);

  const getUserData = async () => {
    const userinfo = await getUserDetails();
    setgetUserInfo(userinfo);
    const storedTheme = localStorage.getItem("themeSettings");

    if (storedTheme) {
      const parsedTheme = JSON.parse(storedTheme);
      setTheme(parsedTheme);

      if (parsedTheme?.logo && parsedTheme.logo.trim() !== "") {
        setLogoUrl(parsedTheme.logo);
      }
    }
    setIsLogoLoading(false);
  };

  useEffect(() => {
    if (themeSettings?.logo && themeSettings.logo.trim() !== "") {
      setLogoUrl(themeSettings.logo);
      setIsLogoLoading(false);
    }
  }, [themeSettings]);

  const useCustomHeader = appTheme?.useCustomHeader || false;
  const headerBackgroundColor = useCustomHeader
    ? appTheme?.headerBackgroundColor
    : "var(--secondary-bg-color)";
  const headerTextColor = useCustomHeader
    ? appTheme?.headerTextColor
    : "var(--secondary-background-text-color)";

  useEffect(() => {
    async function loadUserDetails() {
      try {
        const user = await getUserDetails();
        if (user) {
          setUser(user);
          setgetUserInfo(user);
          if (user.customerId) {
            setCustomerID(user.customerId);
          }
        } else {
          // Handle case when no user found
          // You can add fallback logic here if needed
        }
      } catch (error) {
        navigate("/ats/login");
      }
    }
    loadUserDetails();
  }, []);

  useEffect(() => {
    if (GetUserInfo) {
      let defaultContacts = [];
      let savedPhoneNum = JSON.parse(GetUserInfo.phoneNumbers);
      if (savedPhoneNum.length > 0) {
        selectedCountry?.forEach((list) => {
          let index = savedPhoneNum?.findIndex((x) => x.countryId === list.id);
          let obj = {};
          if (index !== -1) {
            obj["countryId"] = savedPhoneNum[index].countryId;
            obj["name"] = list.name;
            obj["phoneNumber"] = savedPhoneNum[index].phoneNumber;
          } else {
            obj["countryId"] = list.id;
            obj["name"] = list.name;
            obj["phoneNumber"] = "";
          }
          defaultContacts.push(obj);
        });
      } else {
        selectedCountry?.forEach((list) => {
          let obj = {};
          obj["countryId"] = list.id;
          obj["name"] = list.name;
          obj["phoneNumber"] = "";
          defaultContacts.push(obj);
        });
      }

      setUser({
        id: GetUserInfo.id,
        userId: GetUserInfo.userId,
        email: GetUserInfo.email,
        firstName: GetUserInfo.firstName,
        lastName: GetUserInfo.lastName,
        aliasName: GetUserInfo.aliasName,
        phoneNumbers: defaultContacts,
      });
    }
  }, [selectedCountry, GetUserInfo]);

  useEffect(() => {
    if (GetUserInfo) {
      let assignedCountries = JSON.parse(GetUserInfo.selectedcountries);
      if (assignedCountries.length > 0) {
        let cookieCountry = Cookies.get("selectCountry");
        let decryptedCountry = decrypt("selectCountry");
        let selCountry = cookieCountry || decryptedCountry;
        let isCountryAvailable = false;
        let countryObj = null;

        if (selCountry) {
          try {
            countryObj =
              typeof selCountry === "string"
                ? JSON.parse(selCountry)
                : selCountry;
            isCountryAvailable = assignedCountries.some(
              (x) => x.id === countryObj?.id,
            );
          } catch (e) {
            isCountryAvailable = false;
            countryObj = null;
          }
        }

        if (countryObj && isCountryAvailable) {
          setUserCountries(countryObj);
          Cookies.set("selectCountry", JSON.stringify(countryObj), {
            expires: 3,
            path: "/",
            sameSite: "Lax",
            secure: window.location.protocol === "https:",
          });
          Cookies.set("selectCountryId", JSON.stringify(countryObj.id), {
            expires: 3,
            path: "/",
            sameSite: "Lax",
            secure: window.location.protocol === "https:",
          });
          Encrypt(JSON.stringify(countryObj), "selectCountry");
          Encrypt(JSON.stringify(countryObj.id), "selectCountryId");
        } else {
          setUserCountries(assignedCountries[0]);
          Cookies.set("selectCountry", JSON.stringify(assignedCountries[0]), {
            expires: 3,
            path: "/",
            sameSite: "Lax",
            secure: window.location.protocol === "https:",
          });
          Cookies.set("selectCountryId", JSON.stringify(assignedCountries[0].id), {
            expires: 3,
            path: "/",
            sameSite: "Lax",
            secure: window.location.protocol === "https:",
          });
          Encrypt(JSON.stringify(assignedCountries[0]), "selectCountry");
          Encrypt(JSON.stringify(assignedCountries[0].id), "selectCountryId");
        }
        setSelectedCountry(assignedCountries);
      }
      // to remove clients based on customer preference //
      let array = [...pages];
      if (
        GetUserInfo?.clientStatus === null ||
        GetUserInfo?.clientStatus === 0
      ) {
        const clientsIndex = array.findIndex(
          (x) => x.displayName === "Clients",
        );
        if (clientsIndex !== -1) {
          array.splice(clientsIndex, 1);
        }
      }
      if (
        GetUserInfo?.projectStatus === null ||
        GetUserInfo?.projectStatus === 0
      ) {
        const projectsIndex = array.findIndex(
          (x) => x.displayName === "Projects",
        );
        if (projectsIndex !== -1) {
          array.splice(projectsIndex, 1);
        }
      }
      // to remove reports based on customer preference //
      // Show Reports only if 'reports' is included in the features comma-separated string
      const userFeatures = GetUserInfo?.features || "";
      const featuresArray = userFeatures
        .split(",")
        .map((f) => f.trim().toLowerCase());
      if (!featuresArray.includes("reports")) {
        const reportsIndex = array.findIndex(
          (x) => x.displayName === "Reports",
        );
        if (reportsIndex !== -1) {
          array.splice(reportsIndex, 1);
        }
      }
      // Hide nav items for Field Recruiter role
      if (GetUserInfo?.systemroles === "Field Recruiter") {
        const hiddenForFieldRecruiter = [
          "Job Postings",
          "Clients",
          "Projects",
          "Reports",
          "Applicants",
        ];
        array = array.filter(
          (x) => !hiddenForFieldRecruiter.includes(x.displayName),
        );
      }
      setFinalPages(array);
    }
  }, [GetUserInfo]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const onActiveMenuHandler = (page, boolean) => {
    let obj = finalPages;
    obj.forEach((e) => (e.isActive = false));
    let findIndex = obj.findIndex((x) => x.id === page?.id);
    if (findIndex !== -1) {
      obj[findIndex].isActive = true;
    }
    if (boolean) {
      sessionStorage.removeItem("AssociatedId");
    }
  };

  const onMenuActiveHandler = (page, boolean) => {
    dispatch(toggleSidebar(false));
    if (page.displayName === "Applicants") {
      dispatch(resetHighlightFilter([]));
      dispatch(resetSelectedApplicant());
      dispatch(refreshOutlet());
    } else if (page.displayName === "Job Postings") {
      dispatch(resetSelectedJobPosting());
      dispatch(jobpostingsbyidStartReducer({}));
      dispatch(refreshOutlet());
    }
    onActiveMenuHandler(page, true);
  };


  useEffect(() => {
    async function init() {
      try {
        const url = location.pathname;
        let moduleNames = [
          "jobpostings",
          "applicants",
          "clients",
          "projects",
          "reports",
        ];
        let filterPath = moduleNames.filter((x) => url.includes(x))[0];
        let filterMenuObj = pages.filter((x) => x.path.includes(filterPath));
        let isLocalstorageValue = await getUserDetails();
        if (!isLocalstorageValue || isLocalstorageValue === "") {
          preserveThemeAndLogout();
          return;
        }
        if (filterMenuObj.length > 0) {
          onActiveMenuHandler(filterMenuObj[0], false);
        } else {
          finalPages.forEach((e) => (e.isActive = false));
        }
        setDashboardPath(url);
      } catch (error) {
        console.error("Error in dashboard useEffect:", error);
      }
    }
    init();
  }, [location, finalPages]);

  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index, obj) => {
    dispatch(resetHighlightFilter([]));
    if (hasUnsaved) {
      navigate("/ats/layout1");
      setSelectedCountryHold(obj);
    } else {
      setUserCountries(obj);
      setSelectedCountryHold(null);
      Encrypt(JSON.stringify(obj), "selectCountry");
      Encrypt(JSON.stringify(obj.id), "selectCountryId");
      Cookies.set("selectCountry", JSON.stringify(obj), { expires: 3 });
      Cookies.set("selectCountryId", JSON.stringify(obj.id), { expires: 3 });
      const url = location.pathname;
      const isJobposting = url.includes("jobpostings");
      const isApplicants = url.includes("applicants");
      const isClients = url.includes("clients");
      const isProjects = url.includes("projects");
      const isReports = url.includes("reports");

      if (isJobposting) {
        dispatch(resetSelectedJobPosting());
        dispatch(jobpostingsbyidStartReducer({}));
        setTimeout(() => {
          navigate(getJobPostingPath());
        }, 150);
      } else if (isApplicants) {
        dispatch(resetSelectedApplicant());
        setTimeout(() => {
          navigate(getApplicantPath());
        }, 150);
      } else if (isClients) {
        navigate("/ats/layout/clients/landing");
      } else if (isProjects) {
        navigate("/ats/layout/projects/landing");
      } else if (isReports) {
        navigate("/ats/layout/reports/dashboard");
      }
      setTimeout(() => {
        Encrypt(JSON.stringify(""), "allCountryId");
        window.location.reload();
        setAnchorEl(null);
      }, 160);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleHelp = (type) => {
    if (type === "help") {
      navigate("/ats/layout/helpsection/postings");
    } else if (type === "billing") {
      navigate("/ats/layout/customer/billing");
      if (GetUserInfo) {
        setBreadCrumb(GetUserInfo.id, GetUserInfo.companyName, "Billing");
      }
    } else if (type === "settings") {
      navigate("/ats/layout/customer/view");
      if (GetUserInfo) {
        setBreadCrumb(GetUserInfo.id, GetUserInfo.companyName, "Settings");
      }
    } else {
      navigate(`/ats/layout/customer/view`); // ${ GetUserInfo.id}
      if (GetUserInfo) {
        setBreadCrumb(GetUserInfo.id, GetUserInfo.companyName, "Customer");
      }
    }
    handleCloseUserMenu();
  };

  const preserveThemeAndLogout = async () => {
    setLoggedOut(true);
    const themeSettings = localStorage.getItem("themeSettings");

    try {
      await authService.logout();
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Clear everything locally regardless of API success
      // dispatch(updateAuth(null));
      if (!hasUnsaved) {
        // Dispatch clearAuth immediately to update Redux state
        dispatch(clearAuth());
        dispatch(resetStore());
        await persistor.flush();
        await persistor.purge();
        localStorage.clear();
        sessionStorage.clear();
      }
      localStorage.setItem("themeSettings", themeSettings);
      navigate("/ats/login");
    }
  };

  let storedCountryId = null;
  try {
    const rawCountryId =
      Cookies.get("selectCountryId") || decrypt("selectCountryId");
    storedCountryId = rawCountryId ? JSON.parse(rawCountryId) : null;
  } catch (e) {
    storedCountryId = null;
  }

  useEffect(() => {
    let index = selectedCountry?.findIndex((x) => x.id === storedCountryId);
    if (index !== -1 && index !== undefined && selectedCountry) {
      setUserCountries(selectedCountry[index]);
      Encrypt(JSON.stringify(selectedCountry[index]), "selectCountry");
      Encrypt(JSON.stringify(storedCountryId), "selectCountryId");
      Cookies.set("selectCountry", JSON.stringify(selectedCountry[index]), {
        expires: 3,
      });
      Cookies.set("selectCountryId", JSON.stringify(storedCountryId), {
        expires: 3,
      });
    }
  }, [storedCountryId, selectedCountry]);

  const onChangePlatformHandler = (e) => {
    let isChecked = e.target.checked;
    if (hasUnsaved) {
      navigate("/ats/layout");
    } else {
      setAllCountries(isChecked);
      Encrypt(JSON.stringify(!isChecked ? "all" : ""), "allCountryId");
      window.location.reload();
    }
  };

  useEffect(() => {
    if (isConfirmedPopup === "toggle") {
      const cloneValue = !allCountries;
      setAllCountries(cloneValue);
      Encrypt(
        JSON.stringify(cloneValue === false ? "all" : ""),
        "allCountryId",
      );
      window.location.reload();
    } else if (isConfirmedPopup === "dropdown" && selectedCountryHold) {
      setUserCountries(selectedCountryHold);
      Encrypt(JSON.stringify(selectedCountryHold), "selectCountry");
      Encrypt(JSON.stringify(selectedCountryHold.id), "selectCountryId");
      Cookies.set("selectCountry", JSON.stringify(selectedCountryHold), {
        expires: 3,
      });
      Cookies.set("selectCountryId", JSON.stringify(selectedCountryHold.id), {
        expires: 3,
      });
      window.location.reload();
    }
    dispatch(setConfirmed(""));
  }, [isConfirmedPopup]);

  const basePath =
    "https://hirewing-country-assets.s3.ap-south-2.amazonaws.com/Countries";

  const onReceivePropsHandler = (pannel, load, type) => {
    if (type === "updateData") {
      let updatedData = { ...GetUserInfo };
      updatedData.phoneNumbers = JSON.stringify(load.phoneNumbers);
      updatedData.aliasName = load.aliasName;
      updatedData.emailId = updatedData.email;
      dispatch(updateAuth(updatedData));
      dispatch(updateUserDetailsStartReducer(initalState));
    }
    setIsRightSidePannel(pannel);
    getUserData();
  };

  const updateDetailsHandler = () => {
    setIsRightSidePannel(true);
    setAnchorElUser(null);
  };

  return (
    <>
      <AppBar
        position="fixed"
        className="headerBar"
        style={{
          backgroundColor: headerBackgroundColor,
          color: headerTextColor,
        }}
      >
        <Toolbar>
          <div
            style={{
              width: "150px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              dispatch(toggleSidebar(false));
              navigate(
                GetUserInfo?.systemroles === "Field Recruiter"
                  ? "/ats/layout/applicants/list/landing"
                  : "/ats/layout/dashboard",
              );
            }}
          >
            {!isLogoLoading ? (
              <img
                src={logoUrl || DEFAULT_LOGO} // ✅ Default logo if empty
                alt="Company logo"
                className={
                  logoUrl && logoUrl !== DEFAULT_LOGO
                    ? "customLogo"
                    : "hirewingImg"
                }
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }} // ✅ Ensures image fits properly
                onClick={() => {
                  finalPages.map((x) => (x.isActive = false));
                }}
              />
            ) : (
              <div
                style={{
                  width: "150px",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              /> // ✅ Placeholder until logo loads
            )}
          </div>
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              gap: "30px",
              margin: "0px 0 0 30px",
              whiteSpace: "nowrap",
            }}
          >
            {finalPages.map((page) => (
              <Button
                component={Link}
                to={
                  page.displayName === "Applicants"
                    ? getApplicantPath()
                    : page.displayName === "Job Postings" ?
                      getJobPostingPath()
                      : page.path
                }
                key={page.id}
                rel="tag"
                style={{
                  margin: "2px 10px 2px 0",
                  color: headerTextColor,
                  display: "block",
                  padding: "6px 8px",
                  fontSize: "18px",
                  fontWeight: "400",
                  textTransform: "capitalize",
                }}
                className={
                  page.isActive === true ? "activebtn" : "nonactivebtn"
                }
                onClick={() => {
                  onMenuActiveHandler(page, true);
                }}
              >
                {page.displayName}
              </Button>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              minHeight: "70px",
              whiteSpace: "nowrap",
            }}
          >
            {dashboardPath === "/ats/layout/dashboard" && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="allcountrydisplay">
                  {/* <img
                    src={`${process.env.PUBLIC_URL}/assests/img/iconGlobe.svg`}
                    alt="allcontries"
                    style={{ height: '30px' }}
                  /> */}
                  <GlobeIcon />
                </div>

                <p>All Countries</p>
                <span id="headerToggle">
                  <Switch
                    {...label}
                    checked={allCountries}
                    name="allCountries"
                    // disabled={componentType !== "View" ? false : true}
                    onChange={(e) => onChangePlatformHandler(e)}
                    className="headerToggleBtn"
                  />
                </span>
              </div>
            )}

            <List component="nav" aria-label="Device settings">
              <ListItem
                className="countrydisplay"
                id="lock-button"
                // style={{ marginTop: "-4px" }}
                aria-haspopup="listbox"
                aria-controls="lock-menu"
                aria-expanded="true"
                onClick={handleClickListItem}
              >
                <ListItemText
                  className="flagname"
                  style={{
                    display: "flex",
                    gap: "15px",
                    justifyContent: "left",
                    width: "120px",
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  primary={
                    <img
                      src={
                        userCountries
                          ? `${process.env.REACT_APP_IMG_BASEPATH}/${userCountries.logo}`
                          : ""
                      }
                      alt=""
                    />
                  }
                  secondary={userCountries ? userCountries.name : ""}
                />
              </ListItem>
            </List>
            <Menu
              id="lock-menu"
              anchorEl={anchorEl}
              open={open}
              onClick={handleClose}
              onMouseLeave={handleClose}
              className="headerDropdown"
              MenuListProps={{
                "aria-labelledby": "lock-button",
                role: "listbox",
              }}
            >
              {selectedCountry &&
                selectedCountry?.map((option, index) => (
                  <MenuItem
                    style={{
                      display: "flex",
                      gap: "15px",
                      justifyContent: "left",
                      height: "35px",
                      padding: "0 12px",
                      width: "135px",
                      color: "#000",
                    }}
                    // className="menucountrydropdown"
                    key={option.id}
                    selected={
                      option.id === userCountries ? userCountries.id : 0
                    }
                    onClick={(event) =>
                      handleMenuItemClick(event, index, option)
                    }
                  >
                    <img
                      // src={`${process.env.PUBLIC_URL}/assests/img/${option.logo}`} alt=""
                      src={`${basePath}/${option.logo}`}
                      alt=""
                      // className="countryflagsimg"
                      style={{
                        width:
                          option.logo === "004-malaysia.svg" ? "30px" : "30px",
                      }}
                    />
                    <p className="countryflagname">{option.name}</p>
                  </MenuItem>
                ))}
            </Menu>
          </div>
          {/* select flag section end here */}

          <div
            style={{
              display: "flex",
              color: "var(--secondary-background-text-color)",
            }}
          >
            <h4
              style={{
                paddingLeft: "10px",
                fontWeight: "400",
                color: headerTextColor,
              }}
            >
              {GetUserInfo !== null ? GetUserInfo?.companyName : ""}
            </h4>
            <IconButton
              onClick={handleOpenUserMenu}
              style={{ padding: 0, marginRight: "20px", marginLeft: "10px" }}
            >
              <Avatar
                alt="Remy Sharp"
                style={{ backgroundColor: "var(--primary-bg-color)" }}
              >
                <PersonIcon
                  style={{ color: "var(--primary-background-text-color)" }}
                />
              </Avatar>
            </IconButton>
            {/* userdetails start here */}
            <Menu
              style={{ marginTop: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              MenuListProps={{
                "aria-labelledby": "lock-button",
                role: "listbox",
              }}
            >
              <div className="profileMenu">
                <div style={{ display: "block" }}>
                  <div
                    style={{
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    {logoUrl ? (
                      <img
                        src={logoUrl}
                        alt="Company logo"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          height: "47px",
                          marginRight: "13px",
                        }}
                      />
                    ) : (
                      <ProfileIcon
                        primaryColor={appTheme?.primaryColor}
                        primaryFontColor={appTheme?.primaryFontColor}
                      />
                    )}
                    <h3 style={{ paddingLeft: "10px" }}>
                      {GetUserInfo !== null ? GetUserInfo.companyName : ""}
                    </h3>
                  </div>
                  {user !== null && (
                    <>
                      <div className="profileName">
                        <h5>
                          {user.firstName} {user.lastName}
                        </h5>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={updateDetailsHandler}
                        >
                          <ProfileEditIcon
                            primaryColor={appTheme?.primaryColor}
                            primaryFontColor={appTheme?.primaryFontColor}
                          />{" "}
                        </span>
                      </div>
                      <p>{user.email}</p>
                    </>
                  )}
                  <div>
                    <button
                      className="help"
                      onClick={() => {
                        handleHelp("help");
                      }}
                    >
                      Help
                    </button>
                  </div>
                  <div>
                    {GetUserInfo !== null &&
                      (GetUserInfo.systemroles === "Admin" ||
                        GetUserInfo.systemroles === "Manager") ? (
                      <p
                        className="settingstext"
                        onClick={() => {
                          handleHelp("settings");
                        }}
                      >
                        Settings
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <div>
                    {GetUserInfo !== null &&
                    GetUserInfo.systemroles === 'Admin' ? (
                      <p
                        className="settingstext"
                        onClick={() => {
                          handleHelp('billing');
                        }}
                      >
                        Billing
                      </p>
                    ) : (
                      ''
                    )}
                  </div> */}
                </div>
                <div id="signout" style={{ justifyContent: "end" }}>
                  <Button onClick={preserveThemeAndLogout} className="signout">
                    Sign Out
                  </Button>
                </div>
              </div>
            </Menu>
            {/* userdetails end here */}
          </div>
          {/* Mobile hamburger menu */}
          {isMobile && (
            <>
              <IconButton
                className="mobile-hamburger"
                onClick={() => setMobileMenuOpen(true)}
                style={{ color: headerTextColor, marginLeft: "auto" }}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                open={mobileMenuOpen}
                onClose={() => setMobileMenuOpen(false)}
                PaperProps={{
                  style: { width: "70%", maxWidth: "320px" },
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "8px 8px 0",
                  }}
                >
                  <IconButton onClick={() => setMobileMenuOpen(false)}>
                    <CloseIcon />
                  </IconButton>
                </div>
                <div style={{ padding: "10px 20px 20px" }}>
                  {user !== null && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        <Avatar
                          style={{
                            backgroundColor: "var(--primary-bg-color)",
                            width: "60px",
                            height: "60px",
                          }}
                        >
                          <PersonIcon
                            style={{
                              color: "var(--primary-background-text-color)",
                              fontSize: "40px",
                            }}
                          />
                        </Avatar>
                        <h3
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "#000",
                            wordBreak: "break-word",
                          }}
                        >
                          {GetUserInfo !== null ? GetUserInfo.companyName : ""}
                        </h3>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#333",
                            wordBreak: "break-word",
                          }}
                        >
                          {user.firstName} {user.lastName}
                        </h5>
                        <span
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            setMobileMenuOpen(false);
                            updateDetailsHandler();
                          }}
                        >
                          <ProfileEditIcon
                            sx={{ width: "30px", height: "30px" }}
                            primaryColor={appTheme?.primaryColor}
                          />
                        </span>
                      </div>

                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          color: "#000000ff",
                          wordBreak: "break-word",
                        }}
                      >
                        {user.email}
                      </p>
                    </div>
                  )}

                  <div
                    id="signout"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "50px",
                    }}
                  >
                    <Button
                      onClick={() => {
                        setMobileMenuOpen(false);
                        preserveThemeAndLogout();
                      }}
                      style={{
                        backgroundColor: "#fff",
                        color: "#d41317",
                        border: "1px solid #d41317",
                        borderRadius: "10px",
                        padding: "0px 20px",
                        textTransform: "none",
                        fontWeight: "500",
                      }}
                    >
                      Sign Out
                    </Button>
                  </div>
                </div>
              </Drawer>
            </>
          )}
        </Toolbar>
      </AppBar>
      {isRightSidePannel ? (
        <div id="userDetailsPannel">
          {!isMobile ? (
            <RightSideBar
              componentData={
                <ComponentRenderData
                  user={user}
                  onReceivechildProps={onReceivePropsHandler}
                  isMobile={isMobile}
                />
              }
              componentLayout={pannelObj}
              onReceiveProps={onReceivePropsHandler}
            />
          ) : (
            <Drawer
              anchor="right"
              open={isRightSidePannel}
              onClose={() => onReceivePropsHandler(false, "close")}
              PaperProps={{
                style: {
                  width: "100%",
                  maxWidth: "100%",
                  boxShadow: "none",
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 20px 20px",
                  marginTop: "20px",
                }}
              >
                <IconButton
                  onClick={() => onReceivePropsHandler(false, "close")}
                  style={{ padding: 0, color: "#000" }}
                >
                  <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
                </IconButton>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "#000",
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  {pannelObj.title}
                </h2>
                <div style={{ width: "20px" }}></div>
              </div>
              <div style={{ padding: "0 20px 20px" }}>
                <ComponentRenderData
                  user={user}
                  onReceivechildProps={onReceivePropsHandler}
                  isMobile={isMobile}
                />
              </div>
            </Drawer>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
}

const ComponentRenderData = ({ user, onReceivechildProps, isMobile }) => {
  const [userdata, setUserdata] = useState({});
  const dispatch = useDispatch();

  const updateUserDetailsCode = useSelector(
    (state) => state.UpdateUserDetails?.code,
  );

  useEffect(() => {
    if (user) {
      const safePhoneNumbers = Array.isArray(user.phoneNumbers)
        ? user.phoneNumbers
        : [];

      const updatedUserdata = {
        name: `${user.firstName || ""} ${user.lastName || ""}`.trim(),
        emailId: user.email || "",
        aliasName: user.aliasName || "",
        phoneNumbers: safePhoneNumbers,
        userId: user.userId || "",
        id: user.id || "",
      };
      setUserdata(updatedUserdata);
      // Update Formik values safely
      Object.keys(updatedUserdata).forEach((key) => {
        formik.setFieldValue(key, updatedUserdata[key], false);
      });
    }
  }, [user]);

  const validRegex = /^[a-zA-Z0-9_!#$%&*+/=?`{}~^.-]+@[a-zA-Z0-9.-]+$/;
  const phoneRegExp = /^[0-9()+-\s\b]*$/;

  // one phone entry: { name, phoneNumber }
  const phoneSchema = Yup.object().shape({
    name: Yup.string().required("Country name is required"),

    // IMPORTANT: key is phoneNumber (singular)
    phoneNumber: Yup.string()
      .nullable()
      .trim()
      .test(
        "empty-or-valid",
        "Invalid contact number format. Please enter a valid number",
        function (value) {
          // allow empty -> no error if user never typed here
          if (!value) return true;

          // now validate only when there is some text
          if (!phoneRegExp.test(value)) return false;

          if (value.length < 10) {
            return this.createError({ message: "must be 10 characters" });
          }
          if (value.length > 20) {
            return this.createError({ message: "must be less than 20" });
          }
          return true;
        },
      ),
  });

  const validationSchema = Yup.object({
    aliasName: Yup.string()
      .matches(/^[A-Za-z ]*$/, "Please enter valid name")
      .min(3, "Must be min 3 characters")
      .max(20, "Must be less than 20 "),

    // array of phone objects
    phoneNumbers: Yup.array().of(phoneSchema),
  });
  const formik = useFormik({
    initialValues: iniValues,
    validationSchema,
    onSubmit: async (values) => {
      let payload = { ...userdata };
      payload.phoneNumbers = JSON.stringify(payload.phoneNumbers);
      dispatch(updateUserDetailsAsync(payload, payload.id));
    },
  });

  useEffect(() => {
    if (updateUserDetailsCode === 200) {
      // dispatch(updateUserDetailsStartReducer(initalState));
      // setTimeout(() => {
      onReceivechildProps(false, userdata, "updateData");
      // }, 1000);
    }
  }, [updateUserDetailsCode]);

  const handleChange = (value, index, type) => {
    let modified = { ...userdata };
    if (type !== "phoneNumbers") {
      modified[type] = value;
      formik.setFieldValue(type, value);
    } else {
      modified.phoneNumbers[index].phoneNumber = value;
      formik.setFieldValue(`phoneNumbers[${index}].phoneNumber`, value);
    }
    setUserdata(modified);
  };

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <div className="groupfields">
      {isMobile ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "30px",
            marginTop: "10px",
          }}
        >
          <Avatar
            style={{
              backgroundColor: "#FFD800",
              width: "80px",
              height: "80px",
              borderRadius: "25px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            }}
          >
            <PersonIcon
              style={{
                color: "#303030",
                fontSize: "50px",
              }}
            />
          </Avatar>
        </div>
      ) : (
        <UserIcon3
          primaryColor={storedTheme?.primaryColor}
          primaryFontColor={storedTheme?.primaryFontColor}
        />
      )}
      <FocusError formik={formik} />
      <div
        style={{
          display: "flex",
          flexFlow: "wrap",
          marginTop: "40px",
          gap: "22px",
        }}
      >
        <div className="edit-details-field" style={{ width: "48%" }}>
          {isMobile && (
            <div
              style={{
                fontSize: "14px",
                fontWeight: "700",
                color: "#000000ff",
                marginBottom: "8px",
              }}
            >
              Name
            </div>
          )}
          <TextField
            className="boldlabeluser"
            id=""
            label={isMobile ? "" : "Name \u00a0"}
            variant="outlined"
            style={{ width: "100%" }}
            name="name"
            value={userdata.name}
            disabled={true}
            onChange={(e) => handleChange(e.target.value, null, "name")}
            onKeyUp={formik.handleBlur}
            InputLabelProps={isMobile ? undefined : { shrink: true }}
            sx={
              isMobile
                ? {
                  "& .MuiOutlinedInput-root": { backgroundColor: "#fafafa" },
                  "& .MuiOutlinedInput-input": {
                    padding: "10px 14px",
                    fontSize: "14px",
                  },
                }
                : {}
            }
            error={formik.errors.name && formik.touched.name ? true : false}
            helperText={
              formik.errors.name && formik.touched.name
                ? formik.errors.name
                : ""
            }
          />
        </div>
        <div className="edit-details-field" style={{ width: "48%" }}>
          {isMobile && (
            <div
              style={{
                fontSize: "14px",
                fontWeight: "700",
                color: "#000000ff",
                marginBottom: "8px",
              }}
            >
              Email ID
            </div>
          )}
          <TextField
            className="boldlabeluser"
            id=""
            label={isMobile ? "" : "E-mail \u00a0"}
            variant="outlined"
            style={{ width: "100%" }}
            name="emailId"
            value={userdata.emailId}
            disabled={true}
            onChange={(e) => handleChange(e.target.value, null, "emailId")}
            onKeyUp={formik.handleBlur}
            InputLabelProps={isMobile ? undefined : { shrink: true }}
            sx={
              isMobile
                ? {
                  "& .MuiOutlinedInput-root": { backgroundColor: "#fafafa" },
                  "& .MuiOutlinedInput-input": {
                    padding: "10px 14px",
                    fontSize: "14px",
                  },
                }
                : {}
            }
            error={
              formik.errors.emailId && formik.touched.emailId ? true : false
            }
            helperText={
              formik.errors.emailId && formik.touched.emailId
                ? formik.errors.emailId
                : ""
            }
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexFlow: "wrap",
          marginTop: "30px",
          gap: "22px",
        }}
      >
        <div className="edit-details-field" style={{ width: "48%" }}>
          {isMobile && (
            <div
              style={{
                fontSize: "14px",
                fontWeight: "700",
                color: "#000000ff",
                marginBottom: "8px",
              }}
            >
              Alias Name
            </div>
          )}
          <TextField
            className="boldlabeluser"
            id=""
            label={isMobile ? "" : "Alias Name"}
            variant="outlined"
            style={{ width: "100%" }}
            name="aliasName"
            value={userdata.aliasName}
            onChange={(e) => handleChange(e.target.value, null, "aliasName")}
            onKeyUp={formik.handleBlur}
            InputLabelProps={isMobile ? undefined : { shrink: true }}
            sx={
              isMobile
                ? {
                  "& .MuiOutlinedInput-root": { backgroundColor: "#fafafa" },
                  "& .MuiOutlinedInput-input": {
                    padding: "10px 14px",
                    fontSize: "14px",
                  },
                }
                : {}
            }
            error={
              formik.errors.aliasName && formik.touched.aliasName ? true : false
            }
            helperText={
              formik.errors.aliasName && formik.touched.aliasName
                ? formik.errors.aliasName
                : ""
            }
          />
        </div>
        {Array.isArray(userdata.phoneNumbers) &&
          userdata.phoneNumbers.map((list, index) => {
            const fieldName = `phoneNumbers[${index}].phoneNumber`;
            const errorMsg =
              getIn(formik.touched, fieldName) &&
              getIn(formik.errors, fieldName);

            return (
              <div
                className="edit-details-field"
                style={{ width: "48%" }}
                key={index}
              >
                {isMobile && (
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#000000ff",
                      marginBottom: "8px",
                    }}
                  >
                    Phone Number ({list.name})
                  </div>
                )}
                <TextField
                  className="boldlabeluser"
                  label={isMobile ? "" : `Phone Number (${list.name})`}
                  variant="outlined"
                  style={{ width: "100%" }}
                  name={fieldName}
                  value={list.phoneNumber}
                  onChange={(e) =>
                    handleChange(e.target.value, index, "phoneNumbers")
                  }
                  onBlur={formik.handleBlur} // <- IMPORTANT (not onKeyUp)
                  InputLabelProps={isMobile ? undefined : { shrink: true }}
                  sx={
                    isMobile
                      ? {
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#fafafa",
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "10px 14px",
                          fontSize: "14px",
                        },
                      }
                      : {}
                  }
                  error={Boolean(errorMsg)}
                  helperText={errorMsg || ""}
                />
              </div>
            );
          })}
      </div>

      <div
        className="updatebtn"
        style={
          isMobile
            ? {
              display: "flex",
              justifyContent: "center",
              marginTop: "40px",
              marginBottom: "30px",
            }
            : {
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "30px",
            }
        }
      >
        <Button
          className="usersavebtn"
          variant="contained"
          type="submit"
          size="small"
          // disableSubmitBtn={disableSubmitBtn}
          onClick={formik.handleSubmit}
          style={
            isMobile
              ? {
                backgroundColor: "#FFD800",
                color: "#000",
                textTransform: "none",
                fontWeight: "bold",
                padding: "8px 30px",
                borderRadius: "6px",
              }
              : {
                backgroundColor: "var(--primary-bg-color)",
                color: "#000",
                textTransform: "none",
                fontWeight: "500",
                padding: "6px 20px",
              }
          }
        >
          Update
        </Button>
      </div>
    </div>
  );
};

export default Header;

const pannelObj = {
  title: "Edit Details",
  description: "",
  bgImage: "",
};

const iniValues = {
  name: "",
  emailId: "",
  aliasName: "",
  userId: "",
  phoneNumbers: [],
};
